import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'sa-device-icon',
  templateUrl: './device-icon.component.html',
  styleUrls: ['./device-icon.component.scss'],
})
export class DeviceIconComponent {
  @Input() form: string;
  @Input() complianceStatus: string;

  constructor() {}
}
